export default "__VITE_ASSET__C900HLdZ__"